module.exports = __webpack_public_path__ + "media/reskin-images/icon--send-7a129765.svg";